import { search } from './location';
export const dev = process.env.NODE_ENV !== 'development' ? false : search.dev !== 'false';

if (process.env.NODE_ENV === 'development') {
  console.warn('dev', dev);
}
